import React from 'react'
import { EmailSentConfirmation } from './EmailSentConfirmation'
import { PhoneVerificationForm } from './PhoneVerificationForm'
import { RequestCodeForm } from './RequestCodeForm'
import { usePasswordlessLoginForm } from './usePasswordlessLoginForm'

/**
 * This form handles creating/requesting a login code and (for OTP flows) submitting it
 * Supports both SMS verification (OTP) and email (magic link) authentication
 */
export const PasswordlessLoginForm = () => {
  // Use the custom hook to manage all form state and behavior
  const {
    control,
    mode,
    isFetching,
    phoneVerification,
    emailLink,
    onRequestCode,
    onSubmitPhoneCode,
    resetForm,
    isEmailAddress,
    isPhoneNumber,
  } = usePasswordlessLoginForm()

  return (
    <>
      {mode === 'input' && (
        <RequestCodeForm
          control={control}
          onSubmit={onRequestCode}
          isFetching={isFetching}
          isEmailAddress={isEmailAddress}
          isPhoneNumber={isPhoneNumber}
        />
      )}
      {mode === 'email-sent' && emailLink && (
        <EmailSentConfirmation expiresInMinutes={emailLink.expiresInMinutes} onReset={resetForm} />
      )}
      {mode === 'phone-verification' && phoneVerification && (
        <PhoneVerificationForm
          control={control}
          onSubmit={onSubmitPhoneCode}
          onReset={resetForm}
          channel={phoneVerification.channel}
          prettyTel={phoneVerification.prettyTel}
          aliceTel={phoneVerification.aliceTel}
        />
      )}
    </>
  )
}
